export const GET_ALL_PARTIAL_PAYMENTS = "GET_ALL_PARTIAL_PAYMENTS";
export const LOADING_PARTIAL_PAYMENT = "LEADING_PARTIAL_PAYMENT";
export const SET_PARTIAL_PAYMENT = "SET_PARTIAL_PAYMENT";
